<template>
<div  class="achievementTypeindex">
     <div class="header">    
        <el-button size="medium" type="default" @click.native="$router.back()">返回</el-button>  
        <el-button type="primary" size="medium" @click="achievementTypeadd()" >新增</el-button>
        <el-input size="medium" placeholder="请输入学科名称" class="search-input" @change="currQuestionLists()" v-model.trim="listQuery.searchName" style='float: right; width: 20%;'>
            <el-button slot="append" icon="el-icon-search" @click="currQuestionLists()"></el-button>
        </el-input>
      </div>
     <div class="subject">
            <el-table :data="tableData" border :height="windowHeight - 220">
                <el-table-column prop="schoolTypeName" label="学段"  show-overflow-tooltip width="150px"></el-table-column>
              <el-table-column prop="currName" label="学科"  show-overflow-tooltip width="150px"></el-table-column>
              <el-table-column  prop="namelist"  label="题型"    show-overflow-tooltip></el-table-column>
              <el-table-column  label="操作"  align="center" width="150px">
                <template scope="scope">                 
                  <el-button   type="text" size="small" @click="deleteCurrQuestions(scope.row.id)">删除</el-button>
                  <el-button   type="text" size="small" @click="achievementTypeeidt(scope.row.id)">编辑</el-button>
                </template>
              </el-table-column>
           </el-table>
           <div class="pagination-container">
                <el-pagination
                        @size-change="sizeChangeHandler"
                        @current-change="currentChangeHandler"
                        :current-page.sync="listQuery.pageNo"
                        :page-sizes="[10 , 20, 30, 50]"
                        :page-size="listQuery.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-count="listQuery.pages"
                        :total="listQuery.total"
                >
                </el-pagination>
            </div>
     </div>
</div> 
</template>
<script>
import {currQuestionList,deleteCurrQuestion} from "@/api/achievement";
import windowResize from "@/mixins/windowResize";
export default {
  name: "dataAnalysis",
  data() {
    return {
      listQuery: {
        pages: 1,
        total: 0,
        pageNo: 1, //页码
        pageSize: 20, //页数
        searchName: "" //搜索条件
      },
      tableData: [],
    };
  },
  mixins: [windowResize],
  created() {
    this.currQuestionLists();
  },
  methods: {
    //获取列表
    currQuestionLists() {
      currQuestionList(this.listQuery)
        .then(res => {
          const data = res.data.data;
          this.tableData = data.dataList;
          for (let i = 0; i < this.tableData.length; i++) {
            this.tableData[i].namelist = "";
            for (let j = 0; j < this.tableData[i].relationList.length; j++) {
              this.tableData[i].namelist +=
                this.tableData[i].relationList[j].queTypeName + ";";
            }
          }

          this.listQuery.total = data.pagination.total;
          this.listQuery.pages = data.pagination.pages;
        })
        .catch(err => {});
    },
    //删除考试
    deleteCurrQuestions(val) {
      this.$confirm("确定要删除吗？", "提示", {
        type: "warning"
      })
        .then(() => {
          deleteCurrQuestion(val)
            .then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.currQuestionLists();
              }
            })
            .catch(function(error) {});
        })
        .catch(() => {});
    },
    //切换页码
    sizeChangeHandler(pageSize) {
      this.listQuery.pageNo = 1;
      this.listQuery.pageSize = pageSize;
      this.currQuestionLists();
    },
    //切换页数
    currentChangeHandler(pageNo) {
      this.listQuery.pageNo = pageNo;
      this.currQuestionLists();
    },
    //新建
    achievementTypeadd() {
      this.$router.push({
        path: "achievementTypeadd"
      });
    },
    //编辑
    achievementTypeeidt(id) {
      this.$router.push({
        path: "achievementTypeeidt",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.achievementTypeindex {
  padding: 12px;
  .header {
    padding-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/achievement/achievementTypeindex.vue